module.exports = __webpack_public_path__ + "media/images/sites/health/felipe-e128d46f23368a0cbd5f1e0def41f9e8.jpg";